import * as Yup from 'yup';

export const followUpFormSchema = () => {
    const schema = Yup.object().shape({
        followUp: Yup.string().required('An option is required'),
    });

    return schema;
}